import { fontBase } from '@/lib/styleUtils';

// Main footer container
export const footerClasses = [
  fontBase,
  'tw:box-border',
  'tw:w-full tw:pt-base tw:pb-large tw:md:pb-base tw:px-base tw:md:px-huge',
  'tw:bg-white tw:border-t tw:border-solid tw:border-gray-light',
  'tw:flex tw:flex-col tw:md:flex-row tw:items-center tw:justify-center tw:md:justify-end',
  'tw:gap-base tw:md:gap-0',
].join(' ');

// Links container
export const linksContainerClasses = [
  'tw:flex tw:items-center tw:justify-evenly tw:md:justify-center tw:w-full tw:md:w-auto tw:md:gap-huge',
].join(' ');

// Individual link styles
export const linkClasses = [
  'tw:text-gray-dark tw:text-12 tw:md:text-14 tw:font-regular tw:leading-1',
  'tw:no-underline',
  'tw:bg-transparent tw:border-0 tw:p-0',
  'tw:cursor-pointer',
  'tw:whitespace-nowrap',
].join(' ');
